'use strict';
/* @flow */

/**
 * The minimum is the lowest number in the array. With a sorted array,
 * the first element in the array is always the smallest, so this calculation
 * can be done in one step, or constant time.
 *
 * @param {Array<number>} x input
 * @returns {number} minimum value
 * @example
 * minSorted([-100, -10, 1, 2, 5]); // => -100
 */
function minSorted(x /*: Array<number> */)/*:number*/ {
    return x[0];
}

module.exports = minSorted;



/*****************
 ** WEBPACK FOOTER
 ** ./~/simple-statistics/src/min_sorted.js
 ** module id = 741
 ** module chunks = 0
 **/